// mockData.js - Mock data for Cashflow Console

export const cashflowMockData = [
  {
    id: 1,
    cashflowNumber: 'CF-2024-001',
    cashflowStatus: 'Active',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-15',
    tradeNumber: '10767',
    tradeInternalRef: 'TD-INT-001',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 180CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'Enoch LLC',
    costType: 'Primary Settlement',
    contractQuantity: 80000,
    quantity: 79980,
    quantityUOM: 'MT',
    premiumDiscount: 0,
    price: 380.5,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 30440000,
    costPercentage: 0,
    extendedAmount: 30440000,
    invoiceNumber: 'INV-8397',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-28',
    adjustedDueDate: '2024-02-25',
    paymentStatus: 'Partially Paid',
    paymentDate: '2024-02-20',
    itineraryNumber: '702',
    deliveryNumber: '2960',
    storage: 'Fujairah Terminal A',
    level: 'Tank A1',
    commencementDate: '2024-01-20',
    pricingStartDate: '2024-01-10',
    pricingEndDate: '2024-01-25',
    quantityStatus: 'Actual',
    exposure: 15996,
    priceSource: 'Pricing Quotes',
    paymentDescription: 'Advance Payment'
  },
  {
    id: 2,
    cashflowNumber: 'CF-2024-002',
    cashflowStatus: 'Active',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Sell',
    tradeDate: '2024-01-16',
    tradeNumber: '10768',
    tradeInternalRef: 'TD-INT-002',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 180CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'BB Energy',
    costType: 'Primary Settlement',
    contractQuantity: 80000,
    quantity: 79980,
    quantityUOM: 'MT',
    premiumDiscount: 2.5,
    price: 385.75,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 30860000,
    costPercentage: 0,
    extendedAmount: 30860000,
    invoiceNumber: 'INV-8398',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Receivable',
    paymentDueDate: '2024-03-05',
    adjustedDueDate: '2024-03-05',
    paymentStatus: 'Unpaid',
    paymentDate: null,
    itineraryNumber: '702',
    deliveryNumber: '2961',
    storage: 'Jebel Ali Terminal',
    level: 'Tank B2',
    commencementDate: '2024-01-22',
    pricingStartDate: '2024-01-12',
    pricingEndDate: '2024-01-27',
    quantityStatus: 'Actual',
    exposure: 15996,
    priceSource: 'Daily Curve',
    paymentDescription:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
  },
  {
    id: 3,
    cashflowNumber: 'CF-2024-003',
    cashflowStatus: 'Active',
    strategy: '1200',
    strategyExternalReference: 'STR-1200-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-10',
    tradeNumber: '10765',
    tradeInternalRef: 'TD-INT-003',
    commodity: 'Naphtha',
    material: 'Naphtha CIF',
    internalCompany: 'PetroGulf Singapore',
    counterpart: 'Shell Eastern',
    costType: 'Primary Settlement',
    contractQuantity: 50000,
    quantity: 49950,
    quantityUOM: 'MT',
    premiumDiscount: -1.2,
    price: 432.8,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 21640000,
    costPercentage: 0,
    extendedAmount: 21640000,
    invoiceNumber: null,
    invoiceStatus: 'Not Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-15',
    adjustedDueDate: null,
    paymentStatus: 'Unpaid',
    paymentDate: null,
    itineraryNumber: '705',
    deliveryNumber: '2965',
    storage: 'Singapore Storage',
    level: 'Tank S1',
    commencementDate: '2024-01-18',
    pricingStartDate: '2024-01-08',
    pricingEndDate: '2024-01-23',
    quantityStatus: 'Contractual',
    exposure: 9990,
    priceSource: 'Monthly Curve',
    paymentDescription: null
  },
  {
    id: 4,
    cashflowNumber: 'CF-2024-004',
    cashflowStatus: 'Reversed',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-15',
    tradeNumber: '10767',
    tradeInternalRef: 'TD-INT-001',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 180CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'Enoch LLC',
    costType: 'Primary Settlement',
    contractQuantity: 80000,
    quantity: 80000,
    quantityUOM: 'MT',
    premiumDiscount: 0,
    price: 380.5,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 30440000,
    costPercentage: 0,
    extendedAmount: 30440000,
    invoiceNumber: 'INV-8396',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-28',
    adjustedDueDate: '2024-02-25',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-02-25',
    itineraryNumber: '702',
    deliveryNumber: '2960',
    storage: 'Fujairah Terminal A',
    level: 'Tank A1',
    commencementDate: '2024-01-20',
    pricingStartDate: '2024-01-10',
    pricingEndDate: '2024-01-25',
    quantityStatus: 'Contractual',
    exposure: 16000,
    priceSource: 'Pricing Quotes',
    paymentDescription: 'Full Payment'
  },
  {
    id: 5,
    cashflowNumber: 'CF-2024-005',
    cashflowStatus: 'Reversal',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-15',
    tradeNumber: '10767',
    tradeInternalRef: 'TD-INT-001',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 180CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'Enoch LLC',
    costType: 'Primary Settlement',
    contractQuantity: 80000,
    quantity: 80000,
    quantityUOM: 'MT',
    premiumDiscount: 0,
    price: -380.5,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: -30440000,
    costPercentage: 0,
    extendedAmount: -30440000,
    invoiceNumber: 'INV-8396-REV',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-28',
    adjustedDueDate: '2024-02-25',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-02-25',
    itineraryNumber: '702',
    deliveryNumber: '2960',
    storage: 'Fujairah Terminal A',
    level: 'Tank A1',
    commencementDate: '2024-01-20',
    pricingStartDate: '2024-01-10',
    pricingEndDate: '2024-01-25',
    quantityStatus: 'Contractual',
    exposure: 16000,
    priceSource: 'Pricing Quotes',
    paymentDescription: 'Reversal Payment'
  },
  {
    id: 6,
    cashflowNumber: 'CF-2024-006',
    cashflowStatus: 'Active',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-15',
    tradeNumber: '10767',
    tradeInternalRef: 'TD-INT-001',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 180CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'Enoch LLC',
    costType: 'Secondary Cost',
    contractQuantity: 0,
    quantity: 0,
    quantityUOM: 'MT',
    premiumDiscount: 0,
    price: 15000,
    priceCCY: 'USD',
    priceUOM: 'Lumpsum',
    originalExtendedAmount: 15000,
    costPercentage: 0,
    extendedAmount: 15000,
    invoiceNumber: 'INV-8397-COST',
    invoiceStatus: 'Partially Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-03-10',
    adjustedDueDate: null,
    paymentStatus: 'Unpaid',
    paymentDate: null,
    itineraryNumber: '702',
    deliveryNumber: '2960',
    storage: 'Fujairah Terminal A',
    level: 'Tank A1',
    commencementDate: '2024-01-20',
    pricingStartDate: '2024-01-20',
    pricingEndDate: '2024-01-20',
    quantityStatus: 'Actual',
    exposure: 0,
    priceSource: 'Fixed',
    paymentDescription: 'Demurrage Cost'
  },
  {
    id: 7,
    cashflowNumber: 'CF-2024-007',
    cashflowStatus: 'Active',
    strategy: '1300',
    strategyExternalReference: 'STR-1300-EXT',
    buySell: 'Sell',
    tradeDate: '2024-01-20',
    tradeNumber: '10770',
    tradeInternalRef: 'TD-INT-007',
    commodity: 'Gasoline',
    material: 'Gasoline 95 Octane',
    internalCompany: 'PetroGulf Europe',
    counterpart: 'Total Energies',
    costType: 'Primary Settlement',
    contractQuantity: 30000,
    quantity: 30000,
    quantityUOM: 'MT',
    premiumDiscount: 1.8,
    price: 520.4,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 15612000,
    costPercentage: 0,
    extendedAmount: 15612000,
    invoiceNumber: null,
    invoiceStatus: 'Not Invoiced',
    payableReceivables: 'Receivable',
    paymentDueDate: '2024-03-15',
    adjustedDueDate: null,
    paymentStatus: 'Unpaid',
    paymentDate: null,
    itineraryNumber: '710',
    deliveryNumber: '2970',
    storage: 'Rotterdam Terminal',
    level: 'Tank R3',
    commencementDate: '2024-01-28',
    pricingStartDate: '2024-01-18',
    pricingEndDate: '2024-02-02',
    quantityStatus: 'Scheduled',
    exposure: 6000,
    priceSource: 'Daily Curve',
    paymentDescription: null
  },
  {
    id: 8,
    cashflowNumber: 'CF-2024-008',
    cashflowStatus: 'Active',
    strategy: '1250',
    strategyExternalReference: 'STR-1250-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-25',
    tradeNumber: '10772',
    tradeInternalRef: 'TD-INT-008',
    commodity: 'Crude Oil',
    material: 'Brent Crude',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'ExxonMobil',
    costType: 'Provisional Payment',
    contractQuantity: 100000,
    quantity: 100000,
    quantityUOM: 'BBL',
    premiumDiscount: 0,
    price: 78.3,
    priceCCY: 'USD',
    priceUOM: 'BBL',
    originalExtendedAmount: 7830000,
    costPercentage: 80,
    extendedAmount: 7830000,
    invoiceNumber: 'INV-8399-PROV',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-20',
    adjustedDueDate: '2024-02-18',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-02-18',
    itineraryNumber: '715',
    deliveryNumber: '2975',
    storage: 'Fujairah Offshore',
    level: 'FSO-1',
    commencementDate: '2024-02-01',
    pricingStartDate: '2024-01-25',
    pricingEndDate: '2024-02-09',
    quantityStatus: 'Contractual',
    exposure: 20000,
    priceSource: 'Monthly Curve',
    paymentDescription: 'Provisional Payment 80%'
  },
  {
    id: 9,
    cashflowNumber: 'CF-2024-009',
    cashflowStatus: 'Active',
    strategy: '1200',
    strategyExternalReference: 'STR-1200-EXT',
    buySell: 'Buy',
    tradeDate: '2024-01-10',
    tradeNumber: '10765',
    tradeInternalRef: 'TD-INT-003',
    commodity: 'Crude Oil',
    material: 'Brent Crude',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'ExxonMobil',
    costType: 'Provisional Payment',
    contractQuantity: 100000,
    quantity: 10000,
    quantityUOM: 'BBL',
    premiumDiscount: 10,
    price: 74.3,
    priceCCY: 'USD',
    priceUOM: 'BBL',
    originalExtendedAmount: 5830000,
    costPercentage: 80,
    extendedAmount: 4830000,
    invoiceNumber: 'INV-8399-PROV',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-02-20',
    adjustedDueDate: '2024-02-18',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-02-18',
    itineraryNumber: '715',
    deliveryNumber: '2975',
    storage: 'Fujairah Offshore',
    level: 'FSO-1',
    commencementDate: '2024-02-01',
    pricingStartDate: '2024-01-25',
    pricingEndDate: '2024-02-09',
    quantityStatus: 'Contractual',
    exposure: 2000,
    priceSource: 'Monthly Curve',
    paymentDescription: 'Provisional Payment 80%'
  },
  {
    id: 10,
    cashflowNumber: 'CF-2024-010',
    cashflowStatus: 'Active',
    strategy: '1350',
    strategyExternalReference: 'STR-1350-EXT',
    buySell: 'Sell',
    tradeDate: '2024-01-28',
    tradeNumber: '10775',
    tradeInternalRef: 'TD-INT-010',
    commodity: 'Diesel',
    material: 'Diesel 10ppm',
    internalCompany: 'PetroGulf Singapore',
    counterpart: 'BP Singapore',
    costType: 'Primary Settlement',
    contractQuantity: 45000,
    quantity: 44980,
    quantityUOM: 'MT',
    premiumDiscount: 1.2,
    price: 485.6,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 21852000,
    costPercentage: 0,
    extendedAmount: 21852000,
    invoiceNumber: 'INV-8400',
    invoiceStatus: 'Partially Invoiced',
    payableReceivables: 'Receivable',
    paymentDueDate: '2024-03-20',
    adjustedDueDate: '2024-03-18',
    paymentStatus: 'Partially Paid',
    paymentDate: '2024-03-15',
    itineraryNumber: '720',
    deliveryNumber: '2980',
    storage: 'Singapore Terminal',
    level: 'Tank S4',
    commencementDate: '2024-02-05',
    pricingStartDate: '2024-01-28',
    pricingEndDate: '2024-02-12',
    quantityStatus: 'Actual',
    exposure: 8996,
    priceSource: 'Daily Curve',
    paymentDescription: 'Advance Payment 50%'
  },
  {
    id: 11,
    cashflowNumber: 'CF-2024-011',
    cashflowStatus: 'Active',
    strategy: '1150',
    strategyExternalReference: 'STR-1150-EXT',
    buySell: 'Buy',
    tradeDate: '2024-02-01',
    tradeNumber: '10778',
    tradeInternalRef: 'TD-INT-011',
    commodity: 'Fuel Oil',
    material: 'Fuel Oil 380CST',
    internalCompany: 'PetroGulf Dubai',
    counterpart: 'Trafigura',
    costType: 'Primary Settlement',
    contractQuantity: 120000,
    quantity: 119950,
    quantityUOM: 'MT',
    premiumDiscount: -0.8,
    price: 365.2,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 43824000,
    costPercentage: 0,
    extendedAmount: 43824000,
    invoiceNumber: null,
    invoiceStatus: 'Not Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-03-25',
    adjustedDueDate: null,
    paymentStatus: 'Unpaid',
    paymentDate: null,
    itineraryNumber: '725',
    deliveryNumber: '2985',
    storage: 'Fujairah Terminal B',
    level: 'Tank B3',
    commencementDate: '2024-02-08',
    pricingStartDate: '2024-02-01',
    pricingEndDate: '2024-02-16',
    quantityStatus: 'Scheduled',
    exposure: 23990,
    priceSource: 'Pricing Quotes',
    paymentDescription: null
  },
  {
    id: 12,
    cashflowNumber: 'CF-2024-012',
    cashflowStatus: 'Defunct',
    strategy: '1200',
    strategyExternalReference: 'STR-1200-EXT',
    buySell: 'Sell',
    tradeDate: '2024-01-05',
    tradeNumber: '10760',
    tradeInternalRef: 'TD-INT-012',
    commodity: 'Naphtha',
    material: 'Naphtha FOB',
    internalCompany: 'PetroGulf Singapore',
    counterpart: 'Mitsubishi Corp',
    costType: 'Primary Settlement',
    contractQuantity: 35000,
    quantity: 0,
    quantityUOM: 'MT',
    premiumDiscount: 0,
    price: 0,
    priceCCY: 'USD',
    priceUOM: 'MT',
    originalExtendedAmount: 0,
    costPercentage: 0,
    extendedAmount: 0,
    invoiceNumber: 'INV-8395-CANC',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Receivable',
    paymentDueDate: '2024-02-10',
    adjustedDueDate: '2024-02-10',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-02-08',
    itineraryNumber: '698',
    deliveryNumber: '2958',
    storage: 'Singapore Storage',
    level: 'Tank S2',
    commencementDate: '2024-01-12',
    pricingStartDate: '2024-01-05',
    pricingEndDate: '2024-01-20',
    quantityStatus: 'Reversed',
    exposure: 0,
    priceSource: 'Monthly Curve',
    paymentDescription: 'Cancellation Fee'
  },
  {
    id: 13,
    cashflowNumber: 'CF-2024-013',
    cashflowStatus: 'Active',
    strategy: '1400',
    strategyExternalReference: 'STR-1400-EXT',
    buySell: 'Buy',
    tradeDate: '2024-02-05',
    tradeNumber: '10780',
    tradeInternalRef: 'TD-INT-013',
    commodity: 'Crude Oil',
    material: 'WTI Crude',
    internalCompany: 'PetroGulf Europe',
    counterpart: 'Chevron',
    costType: 'Provisional Payment',
    contractQuantity: 75000,
    quantity: 75000,
    quantityUOM: 'BBL',
    premiumDiscount: 0.5,
    price: 76.8,
    priceCCY: 'USD',
    priceUOM: 'BBL',
    originalExtendedAmount: 5760000,
    costPercentage: 85,
    extendedAmount: 5760000,
    invoiceNumber: 'INV-8401-PROV',
    invoiceStatus: 'Fully Invoiced',
    payableReceivables: 'Payable',
    paymentDueDate: '2024-03-10',
    adjustedDueDate: '2024-03-08',
    paymentStatus: 'Fully Paid',
    paymentDate: '2024-03-07',
    itineraryNumber: '730',
    deliveryNumber: '2990',
    storage: 'Rotterdam Offshore',
    level: 'FSO-2',
    commencementDate: '2024-02-12',
    pricingStartDate: '2024-02-05',
    pricingEndDate: '2024-02-20',
    quantityStatus: 'Contractual',
    exposure: 11250,
    priceSource: 'Monthly Curve',
    paymentDescription: 'Provisional Payment 85%'
  },
];

export const filterOptions = {
  cashflowStatus: ["Active", "Reversed", "Reversal", "Defunct"],
  strategy: ["1150", "1200", "1250", "1300"],
  buySell: ["Buy", "Sell"],
  invoiceStatus: ["Not Invoiced", "Partially Invoiced", "Fully Invoiced"],
  paymentStatus: ["Unpaid", "Partially Paid", "Fully Paid"],
  costType: ["Primary Settlement", "Secondary Cost", "Provisional Payment", "Provisional Payment Rev"],
  quantityStatus: ["Contractual", "Actual", "Scheduled", "Reversed", "Reversal"],
  commodity: ["Fuel Oil", "Naphtha", "Gasoline", "Crude Oil", "Diesel"],
  internalCompany: ["PetroGulf Dubai", "PetroGulf Singapore", "PetroGulf Europe"],
  counterpart: ["Enoch LLC", "BB Energy", "Shell Eastern", "Total Energies", "ExxonMobil"]
};

export const savedViews = [
  {
    id: 1,
    name: "All Active Trades",
    description: "View showing all active cashflow records",
    filters: { cashflowStatus: ["Active"] },
    columns: ["cashflowNumber", "tradeNumber", "buySell", "commodity", "quantity", "price", "invoiceStatus", "paymentStatus"]
  },
  {
    id: 2,
    name: "Pending Invoices",
    description: "Records waiting for invoicing",
    filters: { invoiceStatus: ["Not Invoiced"] },
    columns: ["cashflowNumber", "tradeNumber", "counterpart", "quantity", "extendedAmount", "paymentDueDate"]
  },
  {
    id: 3,
    name: "Overdue Payments",
    description: "Records with overdue payments",
    filters: { paymentStatus: ["Unpaid"] },
    columns: ["cashflowNumber", "tradeNumber", "counterpart", "extendedAmount", "paymentDueDate", "adjustedDueDate"]
  },
  {
    id: 4,
    name: "Fuel Oil Portfolio",
    description: "All Fuel Oil related cashflows",
    filters: { commodity: ["Fuel Oil"] },
    columns: ["cashflowNumber", "strategy", "buySell", "quantity", "price", "invoiceStatus", "paymentStatus"]
  }
];

export const columnDefinitions = [
  { field: "cashflowNumber", headerName: "Cashflow Number", width: 150, filterable: true },
  { field: "cashflowStatus", headerName: "Cashflow Status", width: 130, filterable: true },
  { field: "strategy", headerName: "Strategy", width: 100, filterable: true },
  { field: "buySell", headerName: "Buy/Sell", width: 100, filterable: true },
  { field: "tradeNumber", headerName: "Trade Number", width: 120, filterable: true },
  { field: "commodity", headerName: "Commodity", width: 120, filterable: true },
  { field: "counterpart", headerName: "Counterpart", width: 150, filterable: true },
  { field: "internalCompany", headerName: "Internal Company", width: 160, filterable: true },
  { field: "quantity", headerName: "Quantity", width: 100, type: "number" },
  { field: "quantityUOM", headerName: "Qty UOM", width: 90 },
  { field: "price", headerName: "Price", width: 100, type: "number" },
  { field: "priceCCY", headerName: "Price CCY", width: 100 },
  { field: "extendedAmount", headerName: "Extended Amount", width: 150, type: "number" },
  { field: "invoiceStatus", headerName: "Invoice Status", width: 140, filterable: true },
  { field: "paymentStatus", headerName: "Payment Status", width: 140, filterable: true },
  { field: "paymentDueDate", headerName: "Payment Due Date", width: 150, type: "date" },
  { field: "itineraryNumber", headerName: "Itinerary Number", width: 140 },
  { field: "deliveryNumber", headerName: "Delivery Number", width: 140 }
];

// Additional utility functions
export const getCashflowSummary = () => {
  const totalRecords = cashflowMockData.length;
  const totalAmount = cashflowMockData.reduce((sum, item) => sum + (item.extendedAmount || 0), 0);
  const activeRecords = cashflowMockData.filter(item => item.cashflowStatus === "Active").length;
  const pendingInvoices = cashflowMockData.filter(item => item.invoiceStatus === "Not Invoiced").length;
  const unpaidAmount = cashflowMockData
    .filter(item => item.paymentStatus !== "Fully Paid")
    .reduce((sum, item) => sum + (item.extendedAmount || 0), 0);

  return {
    totalRecords,
    totalAmount,
    activeRecords,
    pendingInvoices,
    unpaidAmount
  };
};

export default {
  cashflowMockData,
  filterOptions,
  savedViews,
  columnDefinitions,
  getCashflowSummary
};